/**
 * Coid 2.0 server
 * Coid 2.0 server API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum DisputeStatus {
    NEW = 'NEW',
    OPENED = 'OPENED',
    ON_REVIEW = 'ON_REVIEW',
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED',
    SOLVED = 'SOLVED',
    ON_ARBITRATION = 'ON_ARBITRATION',
    SOLVED_BY_ARBITRATION = 'SOLVED_BY_ARBITRATION',
    EXPIRED = 'EXPIRED',
    RECALLED = 'RECALLED'
}

